import React from 'react'

export default function SubscoreCirclePrint ({displayName, filledIn, notFilledIn, scaleScore}) {
  return (
    <div className={`${displayName} DonutChart Subject`} key={`circle${displayName}`}>
      <svg width="100%" height="100%" viewBox="0 0 42 42" className="donut">
        <circle 
          className="DonutRing" 
          cx="21" cy="21" r="15.91549430918954" 
          fill="transparent" stroke="#d2d3d4" 
          strokeWidth="5">
        </circle>
        <circle 
          className="DonutSegment" 
          cx="21" cy="21" r="15.91549430918954" fill="transparent" 
          stroke={`url(#${displayName.toLowerCase()}-radial)`} 
          strokeWidth="5"
          strokeDasharray={`${filledIn} ${notFilledIn}`} 
          strokeDashoffset="25">
        </circle>
        <circle 
          className="DonutShadow" 
          cx="21" cy="21" r="14" 
          fill="transparent" stroke="rgba(0,0,0,0.08)" 
          strokeWidth="1">
        </circle>
      </svg>
      <div className="ChartText">
        <p className="ChartNumber">
          {scaleScore}
        </p>
        <p className="ChartLabel">
          {displayName}
        </p>
      </div>				
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/SubscoreCirclePrint.js